import { prepareFilter } from "@actions";
import { hideSiteDetailsModal } from "@actions/modals";
import DownloadButton from "@buttons/DownloadButton";
import ExpandButton from "@buttons/ExpandButton";
import RefreshButton from "@buttons/RefreshButton";
import SiteDetailsFilters from "@components/LiveFloorViewer/SiteDetailsFilters";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import { Checkbox, Grid, Header, Label, Modal } from "semantic-ui-react";
import { setSiteDetailsModal } from "../../redux/actions/modals";

const defaultGrid = {
  span: [],
  headerDef: [],
  rowDef: [],
  data: [],
  online: 0,
  offline: 0,
  siteDisplay: "",
};
const defaultRow = { installationId: null };
class SiteDetailsModal extends React.Component {
  state = {
    periodId: 1,
    showEvents: false,
    loadingPositions: false,
    loadingEvents: false,
    grid: defaultGrid,
    events: defaultGrid,
    hideDetails: false,
    siteDisplay: "",
    activeRow: defaultRow,
    offlineOnly: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.modal.open && this.props.modal.open) {
      this.handleRefresh();
    }

    if (
      prevProps.modal.activeRow.installationId !==
      this.props.modal.activeRow.installationId
    ) {
      this.handleRefreshEvents();
    }
  }

  onClose = () =>
    this.setState(
      { grid: defaultGrid, events: defaultGrid, activeRow: defaultRow },
      () => this.props.hideSiteDetailsModal(),
    );

  triggerApiCall = (fnApiCall, fnSuccess, fnFailure) => {
    const { filterSelected, filterData } = this.props.filters;
    const { periodId, siteId } = this.props.modal;
    const { operator, company, subcompany } = filterSelected;
    const { offlineOnly } = this.state;
    this.setState({ activeRow: defaultRow, loadingPositions: true }, () => {
      fnApiCall({
        offlineOnly,
        OperatorId: operator,
        CompanyId: company.id,
        SubCompanyId: subcompany.id,
        SiteId: siteId,
        Manufacturers: prepareFilter(
          filterSelected.manufacturer,
          filterData.manufacturer,
        ),
        GameNames: prepareFilter(filterSelected.game, filterData.game),
        Categories: prepareFilter(
          filterSelected.machinetypes,
          filterData.machinetypes,
        ),
        OperatorRegions: prepareFilter(
          filterSelected.regions,
          filterData.regions,
        ),
        PeriodId: periodId,
      }).then(
        (grid) => fnSuccess(grid),
        () => fnFailure(),
      );
    });
  };

  handleRefresh = () => {
    const { positionsFn } = this.props.modal;
    this.triggerApiCall(
      positionsFn,
      (grid) =>
        this.setState({
          grid,
          loadingPositions: false,
          activeRow: defaultRow,
          events: defaultGrid,
        }),
      () => this.setState({ loadingPositions: false, grid: defaultGrid }),
    );
  };

  handleEventsExportClick = () => {
    const {
      eventsExportFn,
      activeRow: { installationId },
    } = this.props.modal;
    const { periodId, showEvents } = this.state;

    this.setState({ loadingEvents: true }, () => {
      eventsExportFn(installationId, periodId, showEvents)
        .then((events) => handleDownload(events))
        .finally(() => this.setState({ loadingEvents: false }));
    });
  };

  onExportClick = () => {
    const { exportsFn } = this.props.modal;
    this.triggerApiCall(
      exportsFn,
      (response) =>
        this.setState({ loadingPositions: false }, () =>
          handleDownload(response),
        ),
      () => this.setState({ loadingPositions: false }),
    );
  };

  handleRefreshEvents = () => {
    if (!this.props.modal.activeRow.installationId) {
      this.setState({ events: { data: [], headerDef: [], rowDef: [] } });
      return;
    }
    const {
      eventsFn,
      activeRow: { installationId },
    } = this.props.modal;
    const { periodId, showEvents } = this.state;

    this.setState({ loadingEvents: true }, () => {
      eventsFn(installationId, periodId, showEvents).then(
        (events) => this.setState({ events, loadingEvents: false }),
        () => this.setState({ loadingEvents: false, events: defaultGrid }),
      );
    });
  };

  render() {
    const { title, open, activeRow } = this.props.modal;
    const { offlineOnly } = this.state;
    const { hideDetails, events, grid, loadingPositions, loadingEvents } = this.state;

    return (
      <Modal
        open={open}
        onClose={this.onClose}
        size="fullscreen"
        closeIcon
        className="h-80"
      >
        <Modal.Header>{title || "Cash In Box"}</Modal.Header>
        <Modal.Content className="h-100 gs-flex-container-vertical">
          <Grid className="h-100 gs-flex-container-vertical">
            <Grid.Row>
              <Grid.Column width="8" verticalAlign="middle">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className="mb-0_5">
                  <Header size="small" style={{ margin: "auto 0" }}>{grid.siteDisplay}</Header>
                  {grid.isSuspended && (
                    <Label style={{ backgroundColor: "#FFBF00", color: "white" }} className="mr-0_5">
                      OPERATIONS SUSPENDED
                    </Label>
                  )}
                  <Label color="green" content="Online" detail={grid.online} />
                  <Label color="red" content="Offline" detail={grid.offline} />
                  <Checkbox
                    label="Show Offline Only"
                    value={offlineOnly}
                    onChange={() => this.setState({ offlineOnly: !offlineOnly })}
                  />
                </div>
              </Grid.Column>
              <Grid.Column
                width="8"
                textAlign="right"
                verticalAlign="middle"
              >
                <DownloadButton
                  caption="Export"
                  size="medium"
                  onClick={this.onExportClick}
                />
                <RefreshButton
                  size="medium"
                  compact={false}
                  refresh={this.handleRefresh}
                />
                <ExpandButton
                  compact={false}
                  active={hideDetails}
                  size="medium"
                  content={hideDetails ? "Show Details" : "Hide Details"}
                  onClick={() => this.setState({ hideDetails: !hideDetails })}
                />
              </Grid.Column>              
            </Grid.Row>
            <Grid.Row>
              {!hideDetails && (
                <Grid.Column width="7" verticalAlign="bottom">
                  <SiteDetailsFilters
                    {...this.state}
                    onRefreshClick={this.handleRefreshEvents}
                    onEventsExportClick={this.handleEventsExportClick}
                    disabled={!activeRow.installationId}
                    onChange={(_, { name, value }) =>
                      this.setState({ [name]: value })
                    }
                    dis
                  />
                </Grid.Column>
              )}
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column width={!hideDetails ? 9 : 16} stretched>
                <DataGrid
                  groupHeadings={grid.span}
                  headings={grid.headerDef}
                  data={grid.data}
                  rowDef={grid.rowDef}
                  loading={loadingPositions}
                  onRowClick={(activeRow) =>
                    this.props.setSiteDetailsModal({
                      ...this.props.modal,
                      activeRow,
                    })
                  }
                  fullHeight
                />
              </Grid.Column>
              {!hideDetails && (
                <Grid.Column width="7" stretched>
                  <DataGrid
                    headings={events.headerDef}
                    data={events.data}
                    rowDef={events.rowDef}
                    loading={loadingEvents}
                    fullHeight
                  />
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.siteDetailsModal,
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps, {
  hideSiteDetailsModal,
  setSiteDetailsModal,
})(SiteDetailsModal);
